import { Injectable } from '@angular/core';
import { ApiService } from '../../../../core/services/api.service';
import { Observable } from 'rxjs';
import { IPagination, ICompany } from '../../../../modules/authorization/store/types';
import { ICompanyFilters } from 'src/app/modules/logged/companies/store/types';
import { tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class CompanyService {

    constructor(
        private apiService: ApiService
    ) {
    }

    public fetchSearchAll(data: ICompanyFilters): Observable<IPagination> {
        return this.apiService.get('/companies', data);
    }

    public fetchAllCompanies(data: ICompanyFilters): Observable<IPagination> {
        return this.apiService.get('/companies/list/all', data);
    }

    public fetchAllCompaniesForDashboard(): Observable<ICompany[]> {
        return this.apiService.get('/companies/admin-dashboard');
    }

    public fetchOne(id: string): Observable<ICompany> {
        return this.apiService.get(`/companies/${id}`);
    }

    public add(data: any): Observable<any> {
        return this.apiService.post('/companies', data);
    }

    public update(id: string, data: any): Observable<any> {
        return this.apiService.put(`/companies/${id}`, data);
    }

    public delete(id: string): Observable<any> {
        return this.apiService.delete(`/companies/${id}`);
    }

    public addOtherFile(id: string, data: { file: File, description: string }): Observable<any> {
        const formData = new FormData();
        formData.append('file', (data.file || ''));
        formData.append('description', (data.description || ''));
        return this.apiService.put(`/companies/${id}/companyFiles/company_files`, formData);
    }

    public removeOtherFile(id: string, fileId): Observable<any> {
        return this.apiService.delete(`/companies/${id}/removeCompanyFiles/${fileId}`);
    }

    public login(id: string): Observable<any> {
        return this.apiService.get(`/companies/${id}/login`)
            .pipe(
                tap(({ token, refresh_token }) => {
                    const newWindow = window.open(`${location.protocol}//${location.host}`);
                    newWindow.sessionStorage.setItem('token', token);
                    newWindow.sessionStorage.setItem('refreshToken', refresh_token);
                    newWindow.focus();
                })
            );
    }

    public bulkAction(action: string, ids: string[], visible?: boolean): Observable<any> {
        return this.apiService.post(`/companies/bulk/${action}`, { ids, visible });
    }

    public exportCompaniesToXero(): Observable<any> {
        return this.apiService.downloadGet(`/companies/export/xero`);
    }

    public exportCompaniesToCSV(data: any): Observable<any> {
        return this.apiService.downloadGet(`/companies/list/all`, data);
    }

    public uploadContract(companyID: string, file: File): Observable<any> {
        const formData = new FormData();
        formData.append('file', file);
        return this.apiService.post(`/agreements/manual-upload/${companyID}`, formData);
    }

    public getIntermediaryReportCSV(id: string, data: any): Observable<any> {
        return this.apiService.downloadGet(`/companies/${id}/reports/intermediary`, data);
    }

    public getPaymentsReportCSV(id: string, data: any): Observable<any> {
        return this.apiService.downloadGet(`/companies/${id}/reports/payments`, data);
    }
}
